import { create } from 'zustand';

const MAX_ALERTS = 10;

export interface GlobalAlert {
  text: string;
  variant: 'error' | 'success';
}

export interface GlobalAlertState {
  alerts: GlobalAlert[];
}

export interface GlobalAlertActions {
  showGlobalAlert: (alert: GlobalAlert) => void;
  clearGlobalAlert: () => void;
}

export const createGlobalAlertStore = () =>
  create<GlobalAlertState & GlobalAlertActions>((set) => ({
    alerts: [],
    showGlobalAlert: (alert: GlobalAlert) =>
      set((state) => {
        const next = [...state.alerts, alert];
        return { alerts: next.length > MAX_ALERTS ? next.slice(-MAX_ALERTS) : next };
      }),
    clearGlobalAlert: () => set((state) => ({ alerts: state.alerts.slice(1) })),
  }));
